import Vue from 'vue'
import App from './App.vue'
import router from './routes/router'
import store from './store'

import './assets/css/base.css'
import './assets/css/iconfont.css'
import './assets/css/style.css'
import './assets/css/jianrong.css'
import 'element-ui/lib/theme-chalk/index.css';

if (process.env.NODE_ENV === "development") 
//if (true) 
{
  const VConsole = require("vconsole");
  new VConsole();
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
